import tw from "tailwind-styled-components";

export const ReturnsRefundsLoading = () => (
  <Container>
    {[...Array(3)].map((_, i) => (
      <Card key={i}>
        <Header>
          <div className="flex items-center space-x-3">
            <Square className="w-12 h-12" />
            <div className="space-y-2">
              <Line className="w-32 h-4" />
              <Line className="w-24 h-3" />
            </div>
          </div>
          <Badge className="w-24 h-7" />
        </Header>
        <Body>
          <div className="flex gap-4">
            <div className="flex-1 space-y-3">
              <Line className="w-3/4 h-4" />
              <div className="flex space-x-2">
                <Line className="w-12 h-3" />
                <Line className="w-20 h-3" />
              </div>
              <Box className="h-12 w-full" />
            </div>
          </div>
        </Body>
        <Footer>
          <div className="space-y-1">
            <Line className="w-20 h-3" />
            <Line className="w-24 h-5" />
          </div>
          <Button className="w-28 h-9" />
        </Footer>
      </Card>
    ))}
  </Container>
);

const Container = tw.div`animate-pulse space-y-4 md:px-16 md:py-8 p-5`;
const Card = tw.div`bg-white border border-gray-200 rounded-lg shadow-sm`;
const Header = tw.div`p-4 border-b border-gray-100 flex justify-between items-center`;
const Body = tw.div`p-4`;
const Box = tw.div`bg-gray-50 border border-gray-100 rounded-lg`;
const Footer = tw.div`p-4 bg-gray-50 border-t border-gray-100 flex justify-between items-center`;
const Line = tw.div`bg-gray-200 rounded`;
const Square = tw.div`bg-gray-200 rounded-lg`;
const Badge = tw.div`bg-gray-200 rounded-full`;
const Button = tw.div`bg-gray-200 rounded-lg border border-gray-300`;